import angular from 'angular';
import '../../layouts.module';
import template from './reset-password.component.html';
import './reset-password.component.scss';

export const MIN_PASSWORD_LENGTH = 8;

export function passwordProblem(password, confirmation) {
  if (!password || password.length < MIN_PASSWORD_LENGTH) {
    return `Use pelo menos ${MIN_PASSWORD_LENGTH} caracteres.`;
  }
  if (!/[A-Za-z]/.test(password) || !/[0-9]/.test(password)) return 'Use letras e números.';
  if (password !== confirmation) return 'As senhas não conferem.';
  return '';
}

class ResetPasswordController {
  constructor($http, $state, $stateParams, API_BASE_URL) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.API_BASE_URL = API_BASE_URL;
    this.password = '';
    this.confirmation = '';
    this.saving = false;
    this.done = false;
    this.error = '';
  }

  get validLink() {
    return Boolean(this.$stateParams.token && this.$stateParams.empresa);
  }

  submit() {
    this.error = passwordProblem(this.password, this.confirmation);
    if (this.error || !this.validLink) return null;
    this.saving = true;
    return this.$http
      .post(
        `${this.API_BASE_URL}/auth/reset-password`,
        {
          tenantSlug: this.$stateParams.empresa,
          token: this.$stateParams.token,
          newPassword: this.password
        },
        { silentErrors: true }
      )
      .then(() => {
        this.done = true;
      })
      .catch((response) => {
        this.error =
          (response && response.data && response.data.message) ||
          'Não foi possível definir a senha. Peça um novo link a um administrador.';
      })
      .finally(() => {
        this.saving = false;
      });
  }

  useGeneratedPassword(password) {
    this.password = password;
    this.confirmation = password;
    this.error = '';
  }

  goToLogin() {
    this.$state.go('auth.login');
  }
}

ResetPasswordController.$inject = ['$http', '$state', '$stateParams', 'API_BASE_URL'];

angular.module('app.layouts').component('cpResetPassword', {
  controller: ResetPasswordController,
  controllerAs: 'vm',
  template
});
